export enum ButtonColor {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  ACTION = 'ACTION',
  ACTION_AI = 'ACTION_AI',
  DANGER = 'DANGER',
  GHOST = 'GHOST',
  GHOST_SECONDARY = 'GHOST_SECONDARY',
}

export enum ButtonSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum ButtonVariant {
  BASIC = 'BASIC',
  ICON_ATTACHED = 'ICON_ATTACHED',
  ONLY_ICON = 'ONLY_ICON',
}
